import { jsxs as P, jsx as u, Fragment as ie } from "react/jsx-runtime";
import Re, { useMemo as x, useState as $e, useEffect as ke, createElement as Ie } from "react";
import { Typography as be, Flex as S, Checkbox as se, Alert as ye, Spin as Pe, Dropdown as He, Button as le } from "antd";
import { c as ae, b as je, u as We } from "./use-definition-0yWcQDPI.js";
import { HolderOutlined as ze, ArrowLeftOutlined as Ee, ArrowRightOutlined as Fe, CaretDownOutlined as ce, CaretUpOutlined as ue } from "@ant-design/icons";
import { createColumnHelper as Le, useReactTable as Ue, getCoreRowModel as Ve, flexRender as J } from "@tanstack/react-table";
import "./fetcher-CUYp7JR1.js";
import "idb";
import { useSensors as De, useSensor as Be, PointerSensor as Ge, DndContext as Me, closestCenter as Oe } from "@dnd-kit/core";
import { useSortable as Xe, SortableContext as Ye, horizontalListSortingStrategy as Qe } from "@dnd-kit/sortable";
import { CSS as Je } from "@dnd-kit/utilities";
const Ze = (e, t = "—") => e == null || e === "" ? t : typeof e == "string" || typeof e == "number" || typeof e == "boolean" || typeof e == "bigint" ? String(e) : e instanceof Date ? e.toISOString() : JSON.stringify(e), de = (e) => {
  if (!e) return "—";
  const t = new Date(e);
  return Number.isNaN(t.getTime()) ? "—" : t.toLocaleDateString("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "numeric"
  });
}, Ke = (e, t = !0) => {
  if (!e) return "—";
  const [n, r] = e.split(":").map(Number);
  if (Number.isNaN(n) || Number.isNaN(r)) return e;
  const s = new Date(1970, 0, 1, n, r);
  return Number.isNaN(s.getTime()) ? e : s.toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "2-digit",
    hour12: t
  });
}, fe = (e) => {
  if (!e) return "—";
  const t = new Date(e);
  return Number.isNaN(t.getTime()) ? "—" : `${t.toLocaleDateString("en-US", { month: "2-digit", day: "2-digit", year: "numeric" })} ${t.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit" })}`;
}, cn = (e) => {
  if (!e) return "—";
  const t = new Date(e);
  if (Number.isNaN(t.getTime())) return "—";
  const n = Date.now() - t.getTime();
  return `${Math.floor(n / 315576e5)}`;
}, un = (e, t) => `${(e || "?")[0]}${(t || "?")[0]}`.toUpperCase(), dn = (e) => {
  const t = typeof e == "string" || typeof e == "number" ? String(e).replace(/\D/g, "") : "";
  return t.length === 10 ? `(${t.slice(0, 3)}) ${t.slice(3, 6)}-${t.slice(6)}` : Ze(e);
};
function he(e) {
  if (!e) return null;
  const t = e.match(/\bHTTP\s+(\d{3})\b/i);
  if (!t) return null;
  const n = Number(t[1]);
  return Number.isFinite(n) ? n : null;
}
function fn(e) {
  const t = he(e);
  return t === 401 || t === 403 ? !0 : /session|unauthorized|forbidden|expired/i.test(e || "");
}
function qe(e, t = "Something went wrong. Please try again.") {
  if (!e) return t;
  const n = he(e);
  return n === 401 || n === 403 ? "Your session may have expired. Please sign in again." : n === 404 ? "A required resource was not found." : n === 408 || n === 504 ? "The request timed out. Please try again." : n === 502 || n === 503 || n !== null && n >= 500 ? "The service is temporarily unavailable. Please try again in a moment." : /failed to fetch|networkerror|network request failed|load failed/i.test(
    e
  ) ? "Network connection issue. Check your connection and try again." : e.length > 120 || e.includes(`
`) ? t : e;
}
function ve(e, t) {
  return e ? (Array.isArray(e) ? q(e) : e).replace(/\{([\w.]+):\.(\d+)f\}/g, (r, s, c) => {
    const f = pe(
      me(t, s)
    ), l = Number(c), g = Number(f || 0);
    return Number.isFinite(g) ? g.toFixed(l) : 0 .toFixed(l);
  }).replace(
    /\{([\w.]+)\}/g,
    (r, s) => pe(me(t, s))
  ) : "";
}
function me(e, t) {
  return t.includes(".") ? t.split(".").reduce((n, r) => {
    if (n != null && !(typeof n != "object" || Array.isArray(n)))
      return n[r];
  }, e) : e == null ? void 0 : e[t];
}
function pe(e) {
  if (e == null) return "";
  if (typeof e == "object" && !Array.isArray(e)) {
    const t = e, n = t.auto_name ?? t.name ?? t.label ?? t.title ?? t.short_name ?? t.id;
    return typeof n == "string" || typeof n == "number" || typeof n == "boolean" ? String(n) : "";
  }
  return typeof e == "string" || typeof e == "number" || typeof e == "boolean" ? String(e) : "";
}
function q(e) {
  return e ? Array.isArray(e) ? e.length === 0 ? "{name}" : e.map((t) => `{${t}}`).join(" ") : e : "{name}";
}
function ge(e, t) {
  const n = ve(t, e).replace(/\s+/g, " ").trim();
  if (n) return n;
  const r = e.auto_name ?? e.name ?? e.label ?? e.title ?? e.short_name;
  return r != null && (typeof r == "string" || typeof r == "number" || typeof r == "boolean") ? String(r) : "";
}
function K(e, t) {
  if (e == null || !t) return "";
  const n = Array.isArray(t) ? q(t) : t;
  return Array.isArray(e) ? e.map(
    (r) => typeof r == "object" && r !== null ? ge(
      r,
      n
    ) : typeof r == "string" || typeof r == "number" || typeof r == "boolean" || typeof r == "bigint" ? String(r) : ""
  ).filter(Boolean).join(", ") : typeof e == "object" && e !== null ? ge(
    e,
    n
  ) : typeof e == "string" || typeof e == "number" || typeof e == "boolean" || typeof e == "bigint" ? String(e) : "";
}
const et = "_tableContainer_boo9l_1", tt = "_tableWrapper_boo9l_10", nt = "_scrollArea_boo9l_21", rt = "_headerRow_boo9l_82", ot = "_headerCell_boo9l_89", it = "_headerTitleWrap_boo9l_118", st = "_headerTitleText_boo9l_123", lt = "_columnDragHandle_boo9l_138", at = "_sortableHeader_boo9l_154", ct = "_sortIcon_boo9l_158", ut = "_sortIconStack_boo9l_159", dt = "_sortIconActive_boo9l_170", ft = "_resizeHandle_boo9l_185", mt = "_resizeGrip_boo9l_200", pt = "_bodyRow_boo9l_211", gt = "_bodyCell_boo9l_215", bt = "_selectionHeaderCell_boo9l_219", yt = "_selectionCell_boo9l_226", ht = "_selectionCellInner_boo9l_233", _t = "_selectedRow_boo9l_239", St = "_rowStripedEven_boo9l_247", wt = "_rowStripedOdd_boo9l_251", Ct = "_bodyCellWrap_boo9l_274", Nt = "_emptyRow_boo9l_299", Tt = "_alertSpacing_boo9l_304", xt = "_loadingContainer_boo9l_308", At = "_loadingSpinner_boo9l_316", Rt = "_clickableRow_boo9l_320", $t = "_paginationFooter_boo9l_327", d = {
  tableContainer: et,
  tableWrapper: tt,
  scrollArea: nt,
  headerRow: rt,
  headerCell: ot,
  headerTitleWrap: it,
  headerTitleText: st,
  columnDragHandle: lt,
  sortableHeader: at,
  sortIcon: ct,
  sortIconStack: ut,
  sortIconActive: dt,
  resizeHandle: ft,
  resizeGrip: mt,
  bodyRow: pt,
  bodyCell: gt,
  selectionHeaderCell: bt,
  selectionCell: yt,
  selectionCellInner: ht,
  selectedRow: _t,
  rowStripedEven: St,
  rowStripedOdd: wt,
  bodyCellWrap: Ct,
  emptyRow: Nt,
  alertSpacing: Tt,
  loadingContainer: xt,
  loadingSpinner: At,
  clickableRow: Rt,
  paginationFooter: $t
};
function kt(e, t, n) {
  if (t === n)
    return e;
  const r = e.indexOf(t), s = e.indexOf(n);
  if (r === -1 || s === -1)
    return e;
  const c = [...e];
  return c.splice(r, 1), c.splice(s, 0, t), c;
}
function mn(e, t) {
  const n = new Set(e), r = t.filter((s) => !n.has(s));
  return [...e, ...r];
}
const { Text: It } = be, Pt = ({
  columnID: e,
  isDraggable: t,
  titleContent: n,
  sortControl: r,
  showResizeHandle: s,
  onResizeStart: c,
  resizeLabel: f
}) => {
  const {
    attributes: l,
    listeners: g,
    setNodeRef: w,
    transform: N,
    transition: A,
    isDragging: a
  } = Xe({
    id: e,
    disabled: !t
  }), b = {
    transform: Je.Transform.toString(N),
    transition: A,
    opacity: a ? 0.85 : 1,
    zIndex: a ? 3 : void 0
  };
  return /* @__PURE__ */ P(
    S,
    {
      ref: w,
      style: b,
      className: d.headerCell,
      children: [
        /* @__PURE__ */ P(S, { align: "center", gap: 4, className: d.headerTitleWrap, children: [
          t && /* @__PURE__ */ u(
            S,
            {
              align: "center",
              justify: "center",
              className: d.columnDragHandle,
              ...l,
              ...g,
              role: "button",
              tabIndex: 0,
              "aria-label": `Drag ${f} column`,
              children: /* @__PURE__ */ u(ze, { "aria-hidden": !0 })
            }
          ),
          n,
          r
        ] }),
        s && /* @__PURE__ */ u(
          S,
          {
            className: d.resizeHandle,
            onMouseDown: c,
            role: "separator",
            "aria-orientation": "vertical",
            "aria-label": f,
            children: /* @__PURE__ */ u(S, { className: d.resizeGrip, role: "presentation" })
          }
        )
      ]
    }
  );
}, Ht = ({
  isSortable: e,
  onSortClick: t,
  children: n
}) => /* @__PURE__ */ u(
  S,
  {
    align: "center",
    gap: 4,
    className: e ? `${d.sortableHeader} ${d.headerTitleText}` : d.headerTitleText,
    onClick: t,
    role: e ? "button" : void 0,
    tabIndex: e ? 0 : void 0,
    onKeyDown: (r) => {
      e && (r.key === "Enter" || r.key === " ") && (r.preventDefault(), t(
        r
      ));
    },
    children: /* @__PURE__ */ u(It, { strong: !0, children: n })
  }
), jt = ({
  headers: e,
  gridRowStyle: t,
  draggableColumnIDs: n,
  enableColumnReorder: r,
  onColumnOrderChange: s,
  sortableColumnKeys: c,
  onSortHeaderClick: f,
  renderSortIcon: l,
  renderHeaderContent: g,
  onResizeStart: w
}) => {
  const N = De(
    Be(Ge, {
      activationConstraint: { distance: 8 }
    })
  ), A = (C) => {
    const { active: R, over: h } = C;
    if (!h || !s)
      return;
    const $ = String(R.id), p = String(h.id), _ = kt(
      n,
      $,
      p
    );
    _.join("|") !== n.join("|") && s(_);
  }, a = e.map((C, R) => {
    if (C.column.id === "__selection")
      return /* @__PURE__ */ u(
        S,
        {
          className: `${d.headerCell} ${d.selectionHeaderCell}`,
          children: C.isPlaceholder ? null : g(C)
        },
        C.id
      );
    const h = C.column.id, $ = r && h !== "_actions" && n.includes(h), p = `Resize ${String(C.column.columnDef.header ?? h)} column`, _ = R < e.length - 1;
    return /* @__PURE__ */ u(
      Pt,
      {
        columnID: h,
        isDraggable: $,
        resizeLabel: p,
        showResizeHandle: _,
        onResizeStart: (m) => {
          w(h, m);
        },
        titleContent: /* @__PURE__ */ u(
          Ht,
          {
            isSortable: c.has(h),
            onSortClick: (m) => {
              f(h, m);
            },
            children: C.isPlaceholder ? null : g(C)
          }
        ),
        sortControl: l(h)
      },
      C.id
    );
  }), b = /* @__PURE__ */ u(S, { className: d.headerRow, style: t, children: a });
  return r ? /* @__PURE__ */ u(
    Me,
    {
      sensors: N,
      collisionDetection: Oe,
      onDragEnd: A,
      children: /* @__PURE__ */ u(
        Ye,
        {
          items: n,
          strategy: Qe,
          children: b
        }
      )
    }
  ) : b;
};
function Wt(e) {
  return typeof e == "string" || typeof e == "number" || typeof e == "bigint" || typeof e == "boolean";
}
function zt(e, t) {
  const n = e, r = (n == null ? void 0 : n.id) ?? (n == null ? void 0 : n.ID) ?? (n == null ? void 0 : n.uuid) ?? (n == null ? void 0 : n.UUID) ?? (n == null ? void 0 : n.key);
  return r != null && r !== "" && Wt(r) ? String(r) : String(t);
}
function Et(e, t) {
  return t.map(
    (n) => e.accessor(n.dataIndex, {
      id: n.key,
      header: n.title,
      enableSorting: !1,
      meta: n.wrap ? { wrap: !0 } : void 0,
      cell: n.render ? (r) => n.render(r.getValue(), r.row.original) : (r) => r.getValue() ?? ""
    })
  );
}
function Ft(e, t, n = "append") {
  return t != null && t.length ? n === "prepend" ? [...t, ...e] : [...e, ...t] : e;
}
function _e(e) {
  const t = e.trim();
  return t ? t.startsWith("-") ? t.slice(1) : t : "";
}
function pn(e) {
  return e.map((t) => {
    const n = _e(t);
    return n ? {
      id: n,
      desc: t.trim().startsWith("-")
    } : null;
  }).filter((t) => t !== null);
}
function gn(e) {
  return e.map((t) => t.desc ? `-${t.id}` : t.id);
}
function Lt(e) {
  var r, s;
  const t = ((s = (r = e == null ? void 0 : e.ui) == null ? void 0 : r.table) == null ? void 0 : s.sort) ?? [], n = [];
  for (const c of t) {
    const f = _e(c);
    f && !n.includes(f) && n.push(f);
  }
  return n;
}
function bn(e) {
  var t, n;
  return ((n = (t = e == null ? void 0 : e.ui) == null ? void 0 : t.table) == null ? void 0 : n.sort) ?? [];
}
function Ut(e, t) {
  const n = e[0];
  return !n || n.id !== t ? [{ id: t, desc: !1 }] : n.desc ? [] : [{ id: t, desc: !0 }];
}
function yn(e) {
  return e != null && e.field ? [
    e.direction === "DESC" ? `-${e.field}` : e.field
  ] : [];
}
function hn(e) {
  var f;
  if (!e)
    return e;
  const t = new URLSearchParams(e), n = t.get("sort");
  if (!n)
    return e;
  const r = (f = n.split(",")[0]) == null ? void 0 : f.trim();
  if (!r)
    return e;
  const s = r.startsWith("-"), c = s ? r.slice(1) : r;
  return c ? (t.set("sort", c), t.set("order", s ? "DESC" : "ASC"), t.toString()) : e;
}
const { Text: Z } = be, Vt = {}, Dt = ({
  columns: e,
  data: t,
  loading: n = !1,
  error: r = null,
  emptyText: s = "No data",
  pagination: c,
  onRowClick: f,
  getRowContextMenuItems: l,
  getRowID: g,
  buildTableColumnDefs: w,
  customColumnDefs: N,
  customColumnDefsPosition: A = "append",
  rowSelectionMode: a,
  rowSelection: b,
  onRowSelectionChange: C,
  columnWidthsStorageKey: R,
  sorting: h = [],
  onSortingChange: $,
  columnOrder: p,
  onColumnOrderChange: _
}) => {
  const m = x(() => {
    if (!(p != null && p.length))
      return e;
    const o = new Map(e.map((T) => [T.key, T])), i = p.map((T) => o.get(T)).filter((T) => T !== void 0), y = e.filter(
      (T) => !p.includes(T.key)
    );
    return [...i, ...y];
  }, [p, e]), I = x(() => Le(), []), k = x(() => a ? I.display({
    id: "__selection",
    header: a === "multi" ? ({ table: o }) => /* @__PURE__ */ u(
      S,
      {
        align: "center",
        justify: "center",
        className: d.selectionHeaderCell,
        children: /* @__PURE__ */ u(
          se,
          {
            "aria-label": "Select all rows",
            checked: o.getIsAllRowsSelected(),
            indeterminate: o.getIsSomeRowsSelected() && !o.getIsAllRowsSelected(),
            onChange: () => {
              o.toggleAllRowsSelected(
                !o.getIsAllRowsSelected()
              );
            },
            onClick: (i) => {
              i.stopPropagation();
            }
          }
        )
      }
    ) : () => null,
    cell: ({ row: o }) => /* @__PURE__ */ u(
      S,
      {
        align: "center",
        justify: "center",
        className: d.selectionCellInner,
        onClick: (i) => {
          i.stopPropagation();
        },
        role: "presentation",
        children: /* @__PURE__ */ u(
          se,
          {
            "aria-label": "Select row",
            checked: o.getIsSelected(),
            onChange: () => {
              o.toggleSelected();
            },
            onClick: (i) => {
              i.stopPropagation();
            }
          }
        )
      }
    )
  }) : null, [I, a]), W = x(() => {
    const o = w ? w({ columns: m, columnHelper: I }) : Et(
      I,
      m
    ), i = Ft(
      o,
      N,
      A
    );
    return k ? [k, ...i] : i;
  }, [
    w,
    I,
    m,
    N,
    A,
    k
  ]), B = g ?? zt, z = Ue({
    data: t,
    columns: W,
    getCoreRowModel: Ve(),
    getRowId: (o, i) => B(o, i),
    ...a ? {
      state: {
        rowSelection: b ?? {}
      },
      onRowSelectionChange: C,
      enableRowSelection: !0,
      enableMultiRowSelection: a === "multi"
    } : {
      enableRowSelection: !1
    }
  }), E = z.getVisibleLeafColumns(), L = x(() => {
    if (R)
      return R;
    const o = m.map((y) => y.key).join("|"), i = a ? `selection:${a}` : "";
    return `table-widths:${o}:${i}`;
  }, [R, m, a]), U = ae(
    (o) => {
      var i;
      return ((i = o.tablePreferencesByKey[L]) == null ? void 0 : i.columns.widths) ?? Vt;
    }
  ), G = ae(
    (o) => o.setColumnWidth
  ), M = x(() => _ ? (p ?? m.map((i) => i.key)).filter(
    (i) => i !== "__selection" && i !== "_actions"
  ) : [], [p, _, m]), F = x(
    () => new Set(
      m.filter((o) => o.sortable).map((o) => o.key)
    ),
    [m]
  ), [j] = h, [v, ee] = $e(!1);
  ke(() => {
    if (!v)
      return;
    const o = document.body.style.cursor, i = document.body.style.userSelect;
    return document.body.style.cursor = "col-resize", document.body.style.userSelect = "none", () => {
      document.body.style.cursor = o, document.body.style.userSelect = i;
    };
  }, [v]);
  const we = (o, i) => {
    i.stopPropagation(), !(!F.has(o) || !$) && $(Ut(h, o));
  }, Ce = (o) => {
    if (!F.has(o))
      return null;
    const i = (j == null ? void 0 : j.id) === o, y = i ? `${d.sortIcon} ${d.sortIconActive}` : d.sortIcon;
    return i && j.desc ? /* @__PURE__ */ u(ce, { className: y, "aria-hidden": !0 }) : i ? /* @__PURE__ */ u(ue, { className: y, "aria-hidden": !0 }) : /* @__PURE__ */ P(S, { vertical: !0, className: d.sortIconStack, "aria-hidden": !0, children: [
      /* @__PURE__ */ u(ue, { className: d.sortIcon }),
      /* @__PURE__ */ u(ce, { className: d.sortIcon })
    ] });
  }, te = x(() => {
    const o = /* @__PURE__ */ new Map();
    for (const i of m)
      (i.width !== void 0 || i.minWidth !== void 0) && o.set(i.key, { width: i.width, minWidth: i.minWidth });
    return o;
  }, [m]), Ne = (o) => {
    if (o === "__selection")
      return "minmax(40px, 48px)";
    const i = U[o];
    if (i)
      return `${Math.max(i, 96)}px`;
    const y = te.get(o);
    return (y == null ? void 0 : y.width) !== void 0 ? `${y.width}px` : (y == null ? void 0 : y.minWidth) !== void 0 ? `minmax(${y.minWidth}px, 1fr)` : "minmax(var(--table-column-min-width), 1fr)";
  }, ne = x(() => E.length === 0 ? {
    display: "grid",
    gridTemplateColumns: "minmax(var(--table-column-min-width), 1fr)",
    width: "100%"
  } : {
    display: "grid",
    gridTemplateColumns: E.map((i) => Ne(i.id)).join(" "),
    width: "100%"
  }, [U, E, te]), Te = (o, i) => {
    i.preventDefault(), i.stopPropagation();
    const T = i.currentTarget.parentElement, O = T ? T.getBoundingClientRect().width : 0, X = i.clientX;
    ee(!0);
    const V = (Y) => {
      const Q = Y.clientX - X;
      G(
        L,
        o,
        O + Q
      );
    }, D = () => {
      ee(!1), window.removeEventListener("mousemove", V), window.removeEventListener("mouseup", D);
    };
    window.addEventListener("mousemove", V), window.addEventListener("mouseup", D);
  };
  return /* @__PURE__ */ P(S, { vertical: !0, className: d.tableContainer, children: [
    r && /* @__PURE__ */ u(
      ye,
      {
        type: "error",
        title: "Error loading data",
        description: qe(r.message),
        showIcon: !0,
        closable: !0,
        className: d.alertSpacing
      }
    ),
    n && /* @__PURE__ */ u(
      S,
      {
        className: d.loadingContainer,
        align: "center",
        justify: "center",
        children: /* @__PURE__ */ u(
          Pe,
          {
            size: "large",
            tip: "Loading data...",
            className: d.loadingSpinner
          }
        )
      }
    ),
    !r && !n && /* @__PURE__ */ P(S, { vertical: !0, className: d.tableWrapper, children: [
      /* @__PURE__ */ P(S, { vertical: !0, className: d.scrollArea, children: [
        z.getHeaderGroups().map((o) => /* @__PURE__ */ u(
          jt,
          {
            headers: o.headers,
            gridRowStyle: ne,
            draggableColumnIDs: M,
            enableColumnReorder: !!_,
            onColumnOrderChange: _,
            sortableColumnKeys: F,
            onSortHeaderClick: we,
            renderSortIcon: Ce,
            renderHeaderContent: (i) => J(
              i.column.columnDef.header,
              i.getContext()
            ),
            onResizeStart: Te
          },
          o.id
        )),
        z.getRowModel().rows.length === 0 && /* @__PURE__ */ u(
          S,
          {
            justify: "center",
            align: "center",
            className: d.emptyRow,
            children: /* @__PURE__ */ u(Z, { type: "secondary", children: s })
          }
        ),
        z.getRowModel().rows.map((o, i) => {
          const y = (l == null ? void 0 : l(o.original)) ?? [], T = Array.isArray(y) && y.length > 0, O = i % 2 === 0 ? d.rowStripedEven : d.rowStripedOdd, X = o.getIsSelected(), V = !a && (f || T), D = a && (f || T), Y = a && !f && !T, Q = `${d.bodyRow} ${O}${V || D || Y ? ` ${d.clickableRow}` : ""}${X ? ` ${d.selectedRow}` : ""}`, re = /* @__PURE__ */ u(
            "div",
            {
              className: Q,
              style: ne,
              onClick: () => {
                if (!T) {
                  if (a) {
                    f ? f(o.original) : o.toggleSelected();
                    return;
                  }
                  f == null || f(o.original);
                }
              },
              role: "row",
              children: o.getVisibleCells().map((H) => {
                var oe;
                const xe = !!((oe = H.column.columnDef.meta) != null && oe.wrap), Ae = H.column.id === "__selection" ? `${d.bodyCell} ${d.selectionCell}` : xe ? `${d.bodyCell} ${d.bodyCellWrap}` : d.bodyCell;
                return /* @__PURE__ */ u(
                  S,
                  {
                    className: Ae,
                    children: H.column.id === "__selection" ? J(
                      H.column.columnDef.cell,
                      H.getContext()
                    ) : /* @__PURE__ */ u(Z, { children: J(
                      H.column.columnDef.cell,
                      H.getContext()
                    ) })
                  },
                  H.id
                );
              })
            }
          );
          return /* @__PURE__ */ u(Re.Fragment, { children: T ? /* @__PURE__ */ u(
            He,
            {
              menu: { items: y },
              trigger: ["click", "contextMenu"],
              children: re
            }
          ) : re }, o.id);
        })
      ] }),
      c && /* @__PURE__ */ P(
        S,
        {
          justify: "center",
          align: "center",
          gap: 16,
          className: d.paginationFooter,
          children: [
            /* @__PURE__ */ u(
              le,
              {
                size: "small",
                icon: /* @__PURE__ */ u(Ee, {}),
                onClick: c.prevPage,
                disabled: !c.canGoPrev,
                children: "Previous"
              }
            ),
            /* @__PURE__ */ P(Z, { strong: !0, children: [
              "Page ",
              c.page
            ] }),
            /* @__PURE__ */ u(
              le,
              {
                size: "small",
                icon: /* @__PURE__ */ u(Fe, {}),
                iconPlacement: "end",
                onClick: c.nextPage,
                disabled: !c.hasNextPage,
                children: "Next"
              }
            )
          ]
        }
      )
    ] })
  ] });
}, Bt = "_gridContainer_1mk7z_3", Gt = {
  gridContainer: Bt
};
function Se(e, t = "id") {
  if (e == null) return [];
  if (Array.isArray(e))
    return e.flatMap((n) => Se(n, t));
  if (typeof e == "object") {
    const n = e[t];
    return typeof n == "string" || typeof n == "number" ? [n] : [];
  }
  return typeof e == "string" || typeof e == "number" ? [e] : [];
}
function Mt(e) {
  let t = [];
  if (Array.isArray(e))
    t = e;
  else if (e !== null && typeof e == "object" && "data" in e) {
    const n = e.data;
    Array.isArray(n) && (t = n);
  }
  return t.filter(
    (n) => n !== null && typeof n == "object" && !Array.isArray(n)
  );
}
function Ot(e) {
  return typeof e == "string" || typeof e == "number" || typeof e == "boolean" || typeof e == "bigint" ? String(e) : "";
}
function Xt({
  value: e,
  entity: t,
  nameTemplate: n,
  valueField: r = "id"
}) {
  const s = x(
    () => K(e, n),
    [e, n]
  ), c = x(
    () => Se(e, r),
    [e, r]
  ), f = !s && c.length > 0, l = f ? `/${t}/list?limit=${c.length}&_${r}=in:${c.join(",")}` : null, [g] = je(l), w = x(() => {
    if (s) return s;
    if (!f || !g.data) return "";
    const N = new Map(
      Mt(g.data).map((a) => [
        Ot(a[r]),
        a
      ])
    );
    return c.map((a) => {
      const b = N.get(String(a));
      return b ? K(b, n) : "";
    }).filter(Boolean).join(", ");
  }, [s, f, g.data, c, r, n]);
  return w ? /* @__PURE__ */ u(ie, { children: w }) : f && (g.isLoading || g.isFetching) ? /* @__PURE__ */ u(ie, { children: "…" }) : null;
}
function Yt(e) {
  if (e == null || e === "") return "";
  const t = typeof e == "number" ? e : typeof e == "string" ? Number(e) : NaN;
  return Number.isFinite(t) ? new Intl.NumberFormat("en-US", {
    maximumFractionDigits: 2
  }).format(t) : typeof e == "string" || typeof e == "number" || typeof e == "boolean" || typeof e == "bigint" ? String(e) : "";
}
function Qt(e, t) {
  var c, f;
  const {
    type: n,
    target: r,
    ui: { control: s }
  } = e;
  if (n === "relation" && r) {
    let l = function(a) {
      if (a == null) return "empty";
      if (Array.isArray(a))
        return a.map((b) => l(b)).join(",");
      if (typeof a == "object") {
        const b = a[A];
        return typeof b == "string" || typeof b == "number" || typeof b == "boolean" || typeof b == "bigint" ? String(b) : "obj";
      }
      return typeof a == "string" || typeof a == "number" || typeof a == "boolean" || typeof a == "bigint" ? String(a) : "unknown";
    }, g = function(a) {
      const b = K(a, N);
      return b || Ie(Xt, {
        key: `${r}:${l(a)}`,
        value: a,
        entity: r,
        nameTemplate: N,
        valueField: A
      });
    };
    const w = t == null ? void 0 : t[r], N = q((c = w == null ? void 0 : w.ui) == null ? void 0 : c.nameTemplate), A = e.joinColumn ?? e.referencedColumn ?? "id";
    return g;
  }
  if (n === "date")
    return (l) => de(l);
  if (n === "timestamp")
    return (l) => fe(l);
  if (n === "time") {
    const l = ((f = e.ui) == null ? void 0 : f.use12Hours) !== !1;
    return (g) => Ke(g, l);
  }
  return n === "boolean" ? (l) => l === !0 ? "Yes" : l === !1 ? "No" : "" : n === "decimal" ? (l) => Yt(l) : s === "file" ? (l) => (l == null ? void 0 : l.fileName) ?? "" : (l) => {
    if (typeof l == "string") {
      if (l.endsWith("Z")) return fe(l);
      if (/^\d{4}-\d{2}-\d{2}$/.test(l)) return de(l);
    }
    return l == null || typeof l == "object" ? "" : String(l);
  };
}
function Jt({
  entityDef: e,
  entityColOverride: t,
  allDefinitions: n,
  actions: r,
  visibleColumnKeys: s,
  includeActionsColumn: c,
  sortableColumnKeys: f
}) {
  return x(() => {
    var C, R, h, $;
    if (!e) return [];
    const l = t, g = [], w = new Set(f ?? []), N = e.ui.table.columns.filter(
      (p) => p in e.columns
    ), a = !s || s.length === 0 ? N : s, b = new Set(s ?? []);
    for (const p of a) {
      if (!(p in e.columns) || s && s.length > 0 && !b.has(p))
        continue;
      const _ = e.columns[p], m = l == null ? void 0 : l[p], I = m ? { ..._, ...m } : _, k = typeof (m == null ? void 0 : m.render) == "function" ? m.render : Qt(_, n);
      g.push({
        title: ((C = I.ui) == null ? void 0 : C.label) ?? ((R = _.ui) == null ? void 0 : R.label),
        dataIndex: p,
        key: p,
        sortable: w.has(p),
        wrap: (m == null ? void 0 : m.wrap) === !0 || ((h = I.ui) == null ? void 0 : h.wrap) === !0 || (($ = _.ui) == null ? void 0 : $.wrap) === !0,
        ...k ? { render: k } : {}
      });
    }
    return r && c && g.push({
      title: "",
      dataIndex: "_actions",
      key: "_actions",
      render: (p, _) => r(_)
    }), g;
  }, [
    e,
    t,
    n,
    r,
    s,
    c,
    f
  ]);
}
const _n = ({
  entity: e,
  entityColOverride: t,
  customColumnDefs: n,
  customColumnDefsPosition: r,
  gridData: s,
  pagination: c,
  onRowClick: f,
  getRowContextMenuItems: l,
  actions: g,
  entityDefOverride: w,
  visibleColumnKeys: N,
  tablePreferencesKey: A,
  rowSelectionMode: a,
  rowSelection: b,
  onRowSelectionChange: C,
  sortableColumnKeys: R,
  sorting: h,
  onSortingChange: $,
  columnOrder: p,
  onColumnOrderChange: _,
  getRowID: m
}) => {
  var j;
  const k = We().data, W = w ?? (k == null ? void 0 : k[e]), B = Array.isArray((j = s == null ? void 0 : s.data) == null ? void 0 : j.data) && s.data.data.length > 0, z = x(
    () => R ?? Lt(W),
    [W, R]
  ), E = Jt({
    entityDef: W,
    entityColOverride: t,
    allDefinitions: k,
    actions: g,
    visibleColumnKeys: N,
    includeActionsColumn: B,
    sortableColumnKeys: z
  }), { error: L, isLoading: U } = s ?? {}, G = (s == null ? void 0 : s.data) || { data: [] }, M = c ? {
    page: c.page ?? 1,
    hasNextPage: !!c.hasNextPage,
    canGoPrev: !!c.canGoPrev,
    nextPage: c.nextPage,
    prevPage: c.prevPage
  } : void 0, F = x(
    () => p ?? N,
    [p, N]
  );
  return /* @__PURE__ */ P(S, { vertical: !0, className: Gt.gridContainer, children: [
    !W && /* @__PURE__ */ u(ye, { type: "warning", title: "Entity not found", showIcon: !0 }),
    /* @__PURE__ */ u(
      Dt,
      {
        columns: E,
        data: G.data || [],
        loading: U,
        error: L,
        pagination: M,
        onRowClick: f,
        getRowContextMenuItems: l,
        customColumnDefs: n,
        customColumnDefsPosition: r,
        columnWidthsStorageKey: A ? `${A}:column-widths` : void 0,
        rowSelectionMode: a,
        rowSelection: b,
        onRowSelectionChange: C,
        sorting: h,
        onSortingChange: $,
        columnOrder: F,
        onColumnOrderChange: _,
        getRowID: m
      }
    )
  ] });
};
export {
  _n as D,
  Dt as T,
  yn as a,
  Et as b,
  Ut as c,
  zt as d,
  Lt as e,
  pn as f,
  bn as g,
  mn as h,
  ve as i,
  fn as j,
  qe as k,
  Ze as l,
  Ft as m,
  de as n,
  Ke as o,
  fe as p,
  cn as q,
  kt as r,
  gn as s,
  hn as t,
  Jt as u,
  un as v,
  dn as w,
  he as x,
  q as y,
  K as z
};
